import { axiosApi } from "../../../../../api/dbAxios";
import { formatDate } from "../../../../../pages/HomePage/helpers/formatDate";

export const finalizeDraftForm = async (
  form: any,
  files: File[] = [],
  id: string,
) => {
  const test_email = "rborodinov@deloittece.com";
  const isLocalhost =
    typeof window !== "undefined" && window.location.hostname === "localhost";

  const hasArrayField = Object.values(form ?? {}).some(
    (v) => Array.isArray(v) && v.length > 0,
  );
  const filesToSend = hasArrayField ? [...files, ...files] : files;

  const extractVal = (x: any) =>
    x && typeof x === "object" && "value" in x ? x.value : x;

  const formData = new FormData();

  Object.entries(form || {}).forEach(([key, value]) => {
    if ((key === "date" || key === "date_issue") && value) {
      const d = value instanceof Date ? value : new Date(String(value));
      value = formatDate(d);
    }
    if (Array.isArray(value)) {
      value.forEach((item) => {
        const v = extractVal(item);
        formData.append(key, String(v));
      });
    } else {
      const v = extractVal(value);

      if (v == null) return;
      formData.append(key, String(v));
    }
  });

  filesToSend.forEach((file) => formData.append("files", file));

  if (isLocalhost) formData.append("test_email", test_email);

  try {
    const response = await axiosApi.post(
      `/add_record/${form.code}/${id}/`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating draft form:", error);
    throw error;
  }
};
